export const SET_TARGET_FIREARM_TYPES = 'SET_TARGET_FIREARM_TYPES';
export const SET_FIREARM_TYPES_LOOKUP = 'SET_FIREARM_TYPES_LOOKUP';
export const SET_ACTIVITY_LOOKUP = 'SET_ACTIVITY_LOOKUP';
export const SET_EVENT_RULES = 'SET_EVENT_RULES';
export const SET_EVENT_NAME = 'SET_EVENT_NAME';